import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var HouseLaptop = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 640 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M218.3 8.486a31.987 31.987 0 0 1 43.4 0l208 192.014c6.7 6.2 10.3 14.7 10.3 23.5H336c-19.1 0-36.3 8.4-48 21.7V208c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h63.1v128H112c-26.51 0-48-21.5-48-48V256H32c-13.17 0-25.004-8.1-29.802-20.3C-2.6 223.4.615 209.4 10.3 200.5l208-192.014zM336 256h224c17.7 0 32 14.3 32 32v160h32c8.8 0 16 7.2 16 16 0 26.5-21.5 48-48 48H303.1c-25.6 0-48-21.5-48-48 0-8.8 8.1-16 16-16h32V288c0-17.7 15.2-32 32.9-32zm16 48v144h192V304H352z"
  }));
});
HouseLaptop.displayName = 'HouseLaptop';
export var HouseLaptopDimensions = {
  height: 512,
  width: 640
};